import type { User } from "@/types";

/**
 * Archive hub (`/archive`) lists cross-studio archived items with restore / delete-forever.
 * **UX-15:** only **Owner** may use this surface (same shell pattern as **UX-12** hiding unusable Settings tabs for Staff).
 * Ignores stale `studioRoles` rows for studios no longer in `user.studios`.
 */
export function userCanAccessArchiveHub(user: User | null): boolean {
  if (!user) return false;
  const validIds = new Set((user.studios ?? []).map((s) => s.id));
  return (user.studioRoles ?? []).some((sr) => validIds.has(sr.studioId) && sr.role === "Owner");
}
